// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2075":"37dcae28","2589":"d58c8f4e","5685":"c0e87f70"}[chunkId] + ".css";
};